/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

let lastScrollTop = 0;
let lastScrollTopMobile = 0;
const navbar = document.querySelector('header');
var mobileNavActive = false;

const { anime } = window;

if (navbar) {
    const header = navbar.closest('header');
    const navMobile = navbar.querySelector('nav-mobile');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.innerWidth <= 1024) {
                return;
            }
            if (mobileNavActive) {
                return;
            }
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScroll > 100) {
                if (currentScroll > lastScrollTop) {
                    header.style.transform = 'translateY(-100%)';
                    header.style.transition = 'transform 0.2s ease-out';
                    header.classList.remove('scrolled-up');
                } else {
                    header.style.transform = 'translateY(0)';
                    header.style.transition = 'transform 0.2s ease-out';
                    header.classList.add('scrolled-up');
                }
            } else {
                header.style.transform = 'translateY(0)';
            }
            
            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        }, { passive: true });
    }

    if (navMobile) {
        window.addEventListener('scroll', () => {
            if (window.innerWidth >= 1024) return;
            if(mobileNavActive) return;
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScroll > 100) {
                if (currentScroll > lastScrollTopMobile) {
                    navMobile.classList.add('out');
                    navMobile.classList.remove('in');
                } else {
                    navMobile.classList.add('in');
                    navMobile.classList.remove('out');
                }
            } else {
                navMobile.classList.remove('out');
                navMobile.classList.add('in');
            }

            lastScrollTopMobile = currentScroll <= 0 ? 0 : currentScroll;
        }, { passive: true });
    }
}

const menuMobileTrigger = document.querySelector('#klx-navigation__menu-mobile-trigger');
const mobileNav = document.querySelector('.klx-navigation__menu-mobile');

if (menuMobileTrigger && mobileNav) {
    menuMobileTrigger.addEventListener('click', () => {
        const relSrc = menuMobileTrigger.getAttribute('rel-src');
        const src = menuMobileTrigger.getAttribute('src');
        menuMobileTrigger.setAttribute('src', relSrc);
       	menuMobileTrigger.setAttribute('rel-src', src);
        mobileNav.classList.toggle('active');
        mobileNav.parentElement.classList.toggle('active');
        mobileNavActive = !mobileNavActive;
        if(mobileNavActive) {
            window.anime({
                targets: mobileNav,
                opacity: [0, 1],
                filter: ['blur(10px)', 'blur(0px)'],
                duration: 200,
                easing: 'easeOutQuad'
            });
        }
    });
}

// Handle mobile submenu toggles
const mobileSubmenuLinks = document.querySelectorAll('.klx-navigation__menu-mobile .has-submenu');
mobileSubmenuLinks.forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Remove active class from all other submenus at same level
        const currentLevel = link.closest('ul');
        currentLevel.querySelectorAll('.has-submenu').forEach(otherLink => {
            if (otherLink !== link) {
                otherLink.parentElement.querySelector('.klx-submenu-content,.sub-menu')?.classList.remove('active');
                window.anime({
                    targets: otherLink.parentElement.querySelector('.klx-submenu-content,.sub-menu'),
                    height: 0,
                    easing: 'easeInOutSine',
                    duration: 300
                });
            }
        });

        // Toggle active class on clicked submenu
        const submenuContent = link.parentElement.querySelector('.klx-submenu-content,.sub-menu');
        if (submenuContent) {
            submenuContent.classList.toggle('active');
            window.anime({
                targets: submenuContent,
                height: submenuContent.classList.contains('active') ? [0, submenuContent.scrollHeight] : [submenuContent.scrollHeight, 0],
                easing: 'easeInOutSine',
                duration: 300,
            });
        }
    });
});

// Disable page scroll when mobile nav is active
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.target.classList.contains('active')) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    });
});

if (mobileNav) {
    observer.observe(mobileNav, {
        attributes: true,
        attributeFilter: ['class']
    });
}

const body = document.body;
document.querySelectorAll('.has-submenu, .wp-block-klx-submenu, .sub-menu').forEach(submenu => {
    submenu.addEventListener('mouseenter', () => {
        body.classList.add('nav-active');
    });
    submenu.addEventListener('mouseleave', () => {
        body.classList.remove('nav-active');
    });
});

document.querySelectorAll('.menu-item-has-children').forEach(menuItem => {
    const setOffset = () => {
        const rect = menuItem.getBoundingClientRect();
        menuItem.style.setProperty('--submenu-offset', rect.left + 'px');
    };
    
    // Set offset on page load
    setOffset();
    
    // Set offset on hover
    menuItem.addEventListener('mouseenter', setOffset);
});

